<div class="row justify-content-center bgColor">
	<div class="col-11">
		<div class="innerDivBg my-4">
			<div class="innerDiv text-center py-5">
				<h1>Need Help? Contact Us</h1>
				<p>Reach out to us for questions, assistance, complaints and suggestions.</p>
			</div>
			<div class="row justify-content-center">
				<div class="col-md-9 mb-5">
					<div class="row justify-content-center">
						<div class="col-md-4">
							<div class="card myCard">
							  <img class="card-img-top" src="./assets/img/noimage.png" alt="Card image cap">
							  <div class="card-body text-center myCardBody">
							    <h5 class="card-title">{{team.community_manager.name | titlecase}}</h5>
							    <h6>Community Manager</h6>
							    <p class="card-text">Email: wecare@arrivae.com</p>
									<p *ngIf="team.community_manager.contact">Contact: {{team.community_manager.contact}}</p>
									<p *ngIf="team.community_manager.extension">Ext: {{team.community_manager.extension}}</p>
							    <!-- <h4>
							    	<i class="fa fa-envelope"></i>
							    	<i class="fa fa-phone-square"></i>
							    </h4> -->
							  </div>
							</div>
						</div>
						<div class="col-md-4">
							<div class="card myCard">
							  <img class="card-img-top" src="./assets/img/noimage.png">
							  <div class="card-body text-center myCardBody">
							    <h5 class="card-title capitalize">{{team.designer.name | titlecase}}</h5>
							    <h6>Designer</h6>
									 <p class="card-text">Email: wecare@arrivae.com</p> 
									<p *ngIf="team.designer.contact">Contact: {{team.designer.contact}}</p>
									<p *ngIf="team.designer.extension">Ext: {{team.designer.extension}}</p>
							    <!-- <h4>
							    	<i class="fa fa-envelope"></i>
							    	<i class="fa fa-phone-square"></i>
							    </h4> -->
							  </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/customer/meet/meet.component.html